(() => {
  class AccordionImage extends HTMLElement {
    constructor() {
      super();
      this.setVariable();
      this.setEvents();
    }
    setVariable() {
      this.id = this.dataset.id;
      this.imageWrapper = document.querySelector(
        ".index-accordion__image-wrapper"
      );
      this.rightContent = document.querySelector(
        `.index-accordion__video[data-id='${this.id}']`
      );
      if (!this.rightContent) {
        this.rightContent = document.querySelector(
          `.index-accordion__image-left[data-id='${this.id}']`
        );
      }
      this.video = document.querySelector(
        `.index-accordion__video[data-id='${this.id}'] video`
      );
      this.mobileVideo = this.querySelector(
        `.index-accordion__video-mobile  video`
      );
      if (this.video) {
        this.videoAutoplay = this.rightContent.dataset.autoplay;
      }

      this.accordionWrapper = document.querySelector(
        "[data-accordion-image-wrapper]"
      );
      this.contentWrapper = this.querySelector(
        ".index-accordion__item-wrapper"
      );
      this.content = this.querySelector(".index-accordion__item-content");
      this.button = this.querySelector(".index-accordion__button");
    }
    setEvents() {
      const toggleAccordion = this.toggleAccordion.bind(this);
      this.addEventListener("click", (e) => toggleAccordion(e));
    }
    toggleAccordion(e) {
      const isVideo = e.target.closest("video");
      if (this.classList.contains("open")) {
        if (!isVideo) {
          this.closeAccordion();
        }
      } else {
        this.imageWrapper.classList.add("blur");
        const allItems =
          this.accordionWrapper.querySelectorAll("accordion-image");
        allItems.forEach((item) => item.closeAccordion());
        this.openAccordion();
        this.imageWrapper.classList.remove("blur");
      }
    }
    closeAccordion() {
      const screenWidth = window.innerWidth;
      this.classList.remove("open");
      this.contentWrapper.style.transition = `max-height .35s ease-out`;
      this.contentWrapper.style.maxHeight = null;
      this.rightContent.style.display = "none";
      if (screenWidth < 768) {
        if (this.mobileVideo) {
          this.mobileVideo.pause();
          this.mobileVideo.controls = false;
        }
      } else {
        if (this.video) {
          this.video.pause();
          this.video.controls = false;
        }
      }
    }
    openAccordion() {
      const screenWidth = window.innerWidth;
      this.classList.add("open");
      this.contentWrapper.style.transition = `max-height .35s ease-out`;
      this.contentWrapper.style.maxHeight = this.content.scrollHeight + "px";
      if (screenWidth < 768) {
        setTimeout(() => {
          if (this.mobileVideo) {
            this.mobileVideo.controls = true;
            if (this.videoAutoplay === "true") {
              this.mobileVideo.currentTime = 0;
              this.mobileVideo.play();
            }
          }
        });
      } else {
        setTimeout(() => {
          this.rightContent.style.display = "block";
          if (this.video) {
            this.video.controls = true;
            if (this.videoAutoplay === "true") {
              this.video.currentTime = 0;
              this.video.play();
            }
          }
        });
      }
    }
  }
  customElements.define("accordion-image", AccordionImage);

  document.addEventListener("DOMContentLoaded", () => {
    const firstAccordion = document.querySelectorAll("accordion-image")?.[0];
    firstAccordion.click();
  });
})();
